import React from "react";
import tokens from "../shared/design-system/tokens";

/**
 * Global error boundary. A render error anywhere below no longer white-screens
 * the whole app; it shows a recoverable fallback. Wrap <App/> at the root.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // Log for diagnostics; never surface internals to the user.
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ padding: 32, fontFamily: "system-ui, sans-serif", background: tokens.bg, minHeight: "100vh" }}>
        <div style={{ maxWidth: 520, margin: "10vh auto", background: tokens.white, border: `1px solid ${tokens.border}`, borderRadius: 12, padding: 28 }}>
          <h2 style={{ color: tokens.text, margin: "0 0 8px" }}>Something went wrong</h2>
          <p style={{ color: tokens.sub, margin: "0 0 20px" }}>
            An unexpected error occurred. You can reload the page to continue.
          </p>
          <button
            onClick={() => { this.setState({ error: null }); if (typeof window !== "undefined") window.location.reload(); }}
            style={{ background: tokens.accent, color: tokens.white, border: "none", borderRadius: 8, padding: "10px 16px", cursor: "pointer", fontWeight: 600 }}
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
